import type { ReactNode } from 'react'
import { isEmpty } from '@/lib/utils'

/**
 * A text-sized placeholder, `chars` wide and one line tall, for text that is still loading. A `<span>` shown as a
 * block, not the ui Skeleton's `<div>`: it stands inside headings and paragraphs, where a `<div>` is invalid HTML
 * (the parser closes the `<p>` around it, and hydration then mismatches).
 */
export function Skeleton(props: { chars: number; children?: ReactNode }) {
  if (!isEmpty(props.children)) return props.children
  return (
    <span
      data-slot="skeleton"
      className="bg-muted block animate-pulse rounded-md"
      style={{ width: `${props.chars}ch` }}
    >
      &nbsp;
    </span>
  )
}

/**
 * Text whose copy is known before its page loads (a heading, a static paragraph, a nav label), as a placeholder: the
 * real words, set transparent on the skeleton's grey, one bar per line. It wraps where the real text will, at any
 * width and in any language, so the lines it stands in for land where it was.
 */
export function TextBars(props: { children: ReactNode }) {
  return (
    <span data-slot="skeleton" className="bg-muted animate-pulse rounded-md box-decoration-clone text-transparent">
      {props.children}
    </span>
  )
}
